import React, { useState, useEffect } from 'react'
import { Container, Row, Col, Image, Card } from "react-bootstrap";
import ContactForm from './ContactForm'
import { Link } from "react-router";

import gradient from "../../Assets/banner-blue-pill.png";

import { HiOutlineArrowTopRightOnSquare } from "react-icons/hi2";
import { CiMobile1, CiMail, CiLocationOn } from "react-icons/ci";

import './ContactStyle.css'

export default function Contact() {
    return (
        <>
            <div>
                <section className='bg-theme section-hero'>
                    <Container className="header-section py-5">
                        <Row>
                            <Row className='mb-4'>
                                <Col md={7}>
                                    <h2 className="heading-style-h2 pb-3"><span className="text-gradient-1">Contact Us </span></h2>
                                    <h5 className='heading-style-h5 pb-5 text-white'>Have something in mind? Reach out and we’ll understand where you’re at and take it from there. </h5>
                                </Col>
                            </Row>
                            <div className="pills-wrap">

                                <div className="hero-pill-right-wrap animation_slide-up-delay-2">
                                    <Image src={gradient} />
                                </div>
                            </div>
                        </Row>
                    </Container >
                </section >

                <Container className="padding-section-large">
                    <Row className='mb-4'>
                        <Col md={7}>
                            <h2 className="heading-style-h2 pb-3">Drop Us a <span className="text-gradient-1">Line</span></h2>
                            <h5 className='heading-style-h5 pb-5'>Share a few details and we’ll get back to you shortly.</h5>
                        </Col>
                    </Row>
                    <ContactForm />
                </Container>
            </div>
            <section className='padding-section-large bg-gradient-1'>
                <Container>
                    <Row className='mb-4'>
                        <Col md={9}>
                            <h2 className="heading-style-h2 pb-3">Get in <span className="text-gradient-1">Touch</span></h2>
                            <h5 className='heading-style-h5 pb-5'>Got something quick to discuss? Feel free to drop us an email or give us a call. </h5>
                        </Col>
                    </Row>
                    <Row className="d-flex align-items-stretch">
                        <Col md={4} className="mb-4 d-flex" >
                            <Card className="shadow-sm rounded-0 primary-border light-bg logo-bg w-100">
                                <Card.Body className='p-4  d-flex flex-column'>
                                    <CiMail size={36} className='text-gradient-1' />
                                    <small className='text-muted py-2'>Email</small>
                                    <p>Info@parabolait.com </p>
                                </Card.Body>
                            </Card>
                        </Col>
                        <Col md={4} className="mb-4 d-flex" >
                            <Card className="rounded-0 secondary-border w-100">
                                <Card.Body className='p-4  d-flex flex-column'>
                                    <CiMobile1 size={36} className='text-gradient-1' />
                                    <small className='text-muted py-2'>Contact No.</small>
                                    <p>India: +91 7416475326 </p>
                                    <p>USA: +1 385 207 6577 </p>
                                </Card.Body>
                            </Card>
                        </Col>
                        <Col md={4} className="mb-4 d-flex" >
                            <Card className="rounded-0 secondary-border w-100">
                                <Card.Body className='p-4 d-flex flex-column'>
                                    <div className='d-flex gap-3 align-items-center'>
                                        <div className='d-flex flex-column'>
                                            <CiLocationOn size={36} className='text-gradient-1' />
                                            <small className='text-muted py-2'>Address</small>
                                            <p>Plot No.100, Sector-1, MVP Colony, Visakhapatnam 530017, India. </p>
                                        </div>
                                        <div>
                                            <Link to="https://maps.app.goo.gl/nT4j83LVcxx12kZUA" target="_blank" ><HiOutlineArrowTopRightOnSquare size={30} className='text-gradient-1' /></Link>
                                        </div>
                                    </div>
                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </section>
        </>
    )
}
